import { lazyLoad } from './lazyload-init.js';

// Document ready
$(function(){

    /* Content Archive - Content show  */
    
    var $contentArchive = $('.content-archive:not(.custom-template)');

    if( $contentArchive.length ) {
        var $contentButtons = $contentArchive.find('.item-content-show-js');
        var $colContentContaners = $contentArchive.find('.col-content-container');
        let lazyLoadInstance  = lazyLoad(); // Add lazyLoad        

        // Button click
        $contentButtons.on('click', function() {
            var $contentActiveBtn = $(this); // Active btn
            var $contentActiveItem = $contentActiveBtn.closest('.list-item'); // Active list item
            var contentActiveBtnIndex = $contentActiveItem.data('index'); // List item ID
            var parentID = $contentActiveBtn.data('parent-id'); // Content Parent ID
            var $parentList = $('#'+parentID).find('.content-list'); // $Content List container
            var $parentContent = $('#'+parentID).find('.content-archive-container'); // $Content contaner
            var contentID = $contentActiveBtn.data('content-id'); // Content ID
            var itemSiblingIndex = 0;
            var ItemContentOutput = '';

            // Target Siblings
            if (contentActiveBtnIndex % 2 == 0) {
                itemSiblingIndex = contentActiveBtnIndex-1;
            } else {
                itemSiblingIndex = contentActiveBtnIndex+1;
            }

            // Check first content container visibilityy
            var $colContentContainer = $contentActiveItem.nextAll(".col-content-container:visible").first();


            // If NOT active
            if( !$contentActiveItem.hasClass('is-active') ) {
                // Reset all other Items
                // Remove active states
                $parentList.find('.is-active').addClass('is-busy').removeClass('is-active'); // Item active
                $parentList.find('.is-hidden').removeClass('is-hidden'); // items show hidden
                // Fix for index issue
                setTimeout(() => {
                    $parentList.find('.is-busy').removeClass('is-busy')
                }, 800);
                $colContentContaners.removeClass('has-content'); // Col Content Container
                // Reset END

                // Set Item active states
                $contentActiveItem.addClass('is-active'); // Current item active
                $parentList.find('.list-item[data-index='+itemSiblingIndex+']').addClass('is-hidden'); // Sibling hide

                // Set the content
                ItemContentOutput = $parentContent.find('#'+contentID).clone();
                $colContentContainer.html(ItemContentOutput);
                lazyLoadInstance.update(); // Update LazyLoad
                setTimeout(() => {
                    $colContentContainer.addClass('has-content');
                }, 50);
                

            } else {
                // Is active

                // Reset all items
                // Remove active states
                $parentList.find('.is-active').addClass('is-busy').removeClass('is-active'); // Remove active state
                // Fix for index issue
                setTimeout(() => {
                    $parentList.find('.is-busy').removeClass('is-busy')
                }, 800);
                $parentList.find('.is-hidden').removeClass('is-hidden'); // Show hidden items
                // Content Contaners
                $colContentContaners.removeClass('has-content');
                // Reset END
            }
        });
    }
});